import React, { useState } from 'react';
import './services/Common.css';
import { useAuth } from '../AuthContext';
import { useNavigate } from 'react-router-dom';


const About = () => {
    const [activeTab, setActiveTab] = useState('Purpose');
    const { user } = useAuth();
    const navigate = useNavigate();

    const handleTakeAssessment = () => {
        if (user) {
            navigate('/quiz-selection');
        } else {
            navigate('/login');
        }
    };

    return (
            <section id="about-section" className="about-content">
            <div className="hero-section">
                <h1>About Us</h1>
            </div>

                <div className="about-description">
                    <div className="about-details">
                        <div className="principles-section">
                            <p>
                                <b>UNIAARIV</b> is a research-driven consulting firm dedicated to empowering students, businesses, banks, NBFCs
                                with the wisdom of Universal Human Science and Psychology which helps accomplish their aspirations whether
                                it be Growth, Prosperity and Success in the field of their choice.
                            </p>
                            <ul className="principles-list">
                                <li>With over five years of intensive research and 30 years of practical experience, UNIAARIV bridges the gap between subjective perception and objective insights. By integrating Universal Human Science with modern psychology,
                                    we offer clear, unbiased, and structured assessments to help you unlock your full potential and achieve your goals.</li>
                                <li>We do not rely on trial and error. Instead, we apply Universal Human Science and Psychology  and our Proprietary copyrighted framework that evaluates individuals based on their deep-rooted inherent nature.</li>
                                <li>At UNIAARIV, we  work on the principle of <b>complexity to simplicity, confusion to clarity and subjectivity to objectivity</b>.</li>
                                <li>Our mission is to guide you through personal and professional decisions with clear, unbiased, quantitative  and qualitative reports with unique insights like <b>SWOT, Emotional Quotient (EQ), Leadership Quotient (LQ) and Moral Quotient (MQ)</b>.</li>
                                <li>Our approach is rooted in the integration of Universal Human Science and modern psychology, offering a holistic perspective.
                                </li>
                            </ul>
                        </div>

                        <div className="what-we-do">
                            <h3>What We Do</h3>
                            <ul className="services-list">
                                <li>Empower organizations to build high-performance teams that fosters a culture of excellence to lead and succeed</li>
                                <li>Assist students in making informed career choices aligned with their strengths, natural inclination and aspirations</li>
                                <li>Support banks and NBFCs with comprehensive assessments to mitigate credit/loan default risk</li>
                                <li>Help individuals gain deep self-awareness for personal and professional growth</li>
                            </ul>
                            <p className="closing-statement">
                                Whether you're an individual aiming for self-awareness, an organization making strategic HR decisions,
                                student choosing a career, or a bank giving credit - we are here to provide clarity and guidance.
                            </p>
                        </div>

                        <div className="what-we-do">
                            <h3>Key Unique Features of Our Reports</h3>
                            <p><b>Our comprehensive reports covers: -</b></p>

                            <ul className="services-list">
                                <li>Quantitative scores on 17 core parameters, which help quick decision making.</li>
                                <li>Emotional Quotient (EQ): How well an individual understands and manages their emotions and those of others.</li>
                                <li>Moral Quotient (MQ): How well an individual imbibe ethical principles and practice the values in making personal and profession decision-making process.</li>
                                <li>Leadership Quotient (LQ): How well an individual demonstrate leadership qualities including perseverance and resilience etc.</li>
                                <li>SWOT: Detailed insights about the strengths, weaknesses, opportunities, and threats, helping individuals and organizations identify key areas for growth or development.</li>
                                <li>Our Report capture 360 degree insights about a person’s true intrinsic nature, which is otherwise highly difficult to dig out
                                    as the rigid mind never allow a person calmly sit down, stay focused and introspect the self.</li>
                                <li>These insights allow  students to channelize their time and energy to materialize what they are aspiring for, and organizations
                                    in making precise, unbiased decisions regarding talent management, training, leadership development, etc.</li>

                            </ul>
                        </div>

                    </div>
                </div>

            <div className="tabs">
                <button
                    className={activeTab === 'Purpose' ? 'active' : ''}
                    onClick={() => setActiveTab('Purpose')}
                >
                    Our Purpose
                </button>
                <button
                    className={activeTab === 'Vision' ? 'active' : ''}
                    onClick={() => setActiveTab('Vision')}
                >
                    Our Vision
                </button>

            </div>
            <div className="tab-content">
                {activeTab === 'Purpose' && (
                    <div>
                        <p>Our purpose is to empower the next generations and organizations with Universal science based
                            innovative products and services to help accomplish their aspirations whether it be Growth,
                            Prosperity and Success in the field of their choice.
                        </p>
                    </div>
                )}
                {activeTab === 'Vision' && (
                    <div>
                        <p>To be the world leader in offering Universal Science based solutions that bring out the next
                            generations from “confusion to clarity” and enable addressing organizational challenges from
                            “subjectivity to objectivity” and “complexity to simplicity”.
                        </p>
                    </div>
                )}
            </div>
            <div className="take-assessment-container">
                <button className="take-assessment-btn" onClick={handleTakeAssessment}>
                    Take Assessment
                    <svg className="icon" viewBox="0 0 24 24" fill="currentColor">
                        <path
                            fillRule="evenodd"
                            d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
                            clipRule="evenodd"
                        ></path>
                    </svg>
                </button>
            </div>
            </section>
    );
};

export default About;